import { get, post } from './api';
import { BillingItem } from '../models/billingItem';

export interface PaginatedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number; // current page (0-based)
  size: number;
}

export const getBillingItemsByOrder = async (
  orderId: number,
  page = 0,
  size = 20,
  sort?: string
): Promise<PaginatedResponse<BillingItem>> => {
  let url = `/v1/billing-items/order/${orderId}?page=${page}&size=${size}`;
  if (sort) {
    url += `&sort=${encodeURIComponent(sort)}`;
  }
  const response = await get<unknown>(url);
  // Fallback: if response is an array, wrap it as a paginated object
  if (Array.isArray(response)) {
    return {
      content: response as BillingItem[],
      totalElements: response.length,
      totalPages: 1,
      number: 0,
      size: response.length
    };
  }
  return response as PaginatedResponse<BillingItem>;
};

export const reviewBillingItem = async (
  billingItemId: number,
  reviewerId: string,
  comment?: string
): Promise<BillingItem> => {
  const response = await post<BillingItem>(
    `/v1/billing-items/${billingItemId}/review?reviewerId=${reviewerId}${
      comment ? `&comment=${encodeURIComponent(comment)}` : ''
    }`
  );
  console.log('Review response:', response);
  return response;
};

export const approveBillingItem = async (
  billingItemId: number,
  approverId: string,
  comment?: string
): Promise<BillingItem> => {
  return post(
    `/v1/billing-items/${billingItemId}/approve?approverId=${approverId}${
      comment ? `&comment=${encodeURIComponent(comment)}` : ''
    }`
  );
};

export const rejectBillingItem = async (
  billingItemId: number,
  userId: string,
  comment?: string
): Promise<BillingItem> => {
  return post(
    `/v1/billing-items/${billingItemId}/reject?userId=${userId}${
      comment ? `&comment=${encodeURIComponent(comment)}` : ''
    }`
  );
};

export const requestChanges = async (
  billingItemId: number,
  reviewerId: string,
  comment?: string
): Promise<BillingItem> => {
  return post(
    `/v1/billing-items/${billingItemId}/request-changes?reviewerId=${reviewerId}${
      comment ? `&comment=${encodeURIComponent(comment)}` : ''
    }`
  );
};
